import {
  JOBTASKLIST_FETCHING,
  JOBTASKLIST_SUCCESS,
  JOBTASKLIST_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOBTASKLIST_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOBTASKLIST_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOBTASKLIST_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
